import { IStoreItem, STORE_ITEM_TYPES } from "@/store/apis/storeAPI"
import { BuyGoldCard } from "./BuyGoldCard"

export const SHOP_MODALS = {
  buyGoldCard: {
    component: BuyGoldCard,
    params: {} as IStoreItem<STORE_ITEM_TYPES.CARD>
  }
} as const
